import axios from 'axios';

const api = axios.create({
    baseURL: '/api',
});

export const getServers = () => api.get('/servers');
export const getServer = (name) => api.get(`/servers/${encodeURIComponent(name)}`);
export const getServerState = (name) => api.get(`/servers/${encodeURIComponent(name)}/state`);
export const startServer = (name) => api.post(`/servers/${encodeURIComponent(name)}/state/start`);
export const stopServer = (name) => api.post(`/servers/${encodeURIComponent(name)}/state/stop`);
export const createServer = (data) => api.post('/servers', data);
export const updateSettings = (name, data) => api.patch(`/servers/${encodeURIComponent(name)}`, data);
export const uploadMod = (name, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/servers/${encodeURIComponent(name)}/mods`, formData);
};
export const deleteMod = (name, fileName) => api.delete(`/servers/${encodeURIComponent(name)}/mods/${encodeURIComponent(fileName)}`);
export const deleteServer = (name) => api.delete(`/servers/${encodeURIComponent(name)}`);

// CurseForge API
export const searchCurseForge = (query, version, loader, classId = 6, sortField = 2, limit = 20, offset = 0) => 
    api.get('/curseforge/search', { params: { query, version, loader, classId, sortField, limit, offset } });

export const getPopularCurseForge = (version, loader, classId = 6, limit = 20, offset = 0) => 
    api.get('/curseforge/popular', { params: { version, loader, classId, limit, offset } });

export const getCurseForgeMod = (modId) => api.get(`/curseforge/mod/${modId}`);

export const installCurseForgeMod = (serverName, modData) => 
    api.post(`/servers/${encodeURIComponent(serverName)}/curseforge/install`, modData);

// Advanced Administration Features
export const sendConsoleCommand = (name, command) => 
    api.post(`/servers/${encodeURIComponent(name)}/command`, { command });

export const getServerStats = (name) => 
    api.get(`/servers/${encodeURIComponent(name)}/stats`);

export const uploadDatapack = (name, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/servers/${encodeURIComponent(name)}/datapacks`, formData);
};

export const addWhitelistUser = (name, username) => 
    api.post(`/servers/${encodeURIComponent(name)}/whitelist`, { username });

export const removeWhitelistUser = (name, username) => 
    api.delete(`/servers/${encodeURIComponent(name)}/whitelist/${encodeURIComponent(username)}`);

export const addOpUser = (name, username) => 
    api.post(`/servers/${encodeURIComponent(name)}/ops`, { username });

export const removeOpUser = (name, username) => 
    api.delete(`/servers/${encodeURIComponent(name)}/ops/${encodeURIComponent(username)}`);

// Whitelist and Ops Fetching
export const getWhitelist = (name) => 
    api.get(`/servers/${encodeURIComponent(name)}/whitelist`);

export const getOps = (name) => 
    api.get(`/servers/${encodeURIComponent(name)}/ops`);

// Backup API calls
export const getBackups = (name) => 
    api.get(`/servers/${encodeURIComponent(name)}/backups`);

export const createBackup = (name) => 
    api.post(`/servers/${encodeURIComponent(name)}/backups`);

export const deleteBackup = (name, backupName) => 
    api.delete(`/servers/${encodeURIComponent(name)}/backups/${encodeURIComponent(backupName)}`);

export const restoreBackup = (name, backupName) => 
    api.post(`/servers/${encodeURIComponent(name)}/backups/${encodeURIComponent(backupName)}/restore`);

// File Manager API calls
export const listFiles = (name, path) => 
    api.get(`/servers/${encodeURIComponent(name)}/files`, { params: { path } });

export const readFileContent = (name, path) => 
    api.get(`/servers/${encodeURIComponent(name)}/files/view`, { params: { path } });

export const saveFileContent = (name, path, content) => 
    api.post(`/servers/${encodeURIComponent(name)}/files`, { path, content });

export const deleteFile = (name, path) => 
    api.delete(`/servers/${encodeURIComponent(name)}/files`, { params: { path } });

export default api;